import $http from '../../axios';
import {Notification} from 'element-ui';

/**
 * Obtener suscriptor.
 */
export async function getSubscriber({commit}) {
    await $http.get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
        })
        .catch(error => {
        });
}

/**
 * Obtener suscriptor.
 */
export async function sync({commit, dispatch, state}) {

    commit('setLoading', true);

    await $http.post(`/api/integracion-b2c/sync`)
        .then(response => {
            commit('setLoading', false);
            Notification.success({
                title: '¡Muy bien!',
                message: response.data.message,
                type: 'success',
                duration: 5000,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            commit('setLoading', false);
            console.log(error);
            Notification.error({
                title: '¡Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 5000,
                customClass: 'notification-box'
            });
        });
}




// WEBPACK FOOTER //
// ./src/modules/b2c_integration/actions.js